import React from 'react';

const StyleButton = ( { style, onToggle, active, label } ) => {
    const onMouseDown = ( e ) => {
        e.preventDefault();
        onToggle( style );
    };

    const className = !active ? 'rte-style-button' : 'rte-style-button rte-active-button';

    return (
        <span className={ className } onMouseDown={ onMouseDown }>
            { label }
        </span>
    );

};

export default StyleButton;